export async function getResponseBody(res) {
  try {
    return await res.json();
  } catch (e) {}
}
